import { defineMessages } from 'react-intl'

export default defineMessages({
  sessionExpired: {
    defaultMessage: 'Deine Session ist abgelaufen. Bitte melde dich erneut an.',
  },
  welcomeTitle: {
    defaultMessage: 'Willkommen im PIP‑Assessment',
  },
  welcomeText: {
    defaultMessage:
      'Assessmentinstrument für den Einsatz bei Beratungsgesprächen zu Pflegeleistungen zur Prävention und Intervention in der häuslichen Pflege',
  },
  welcomeNote: {
    defaultMessage:
      'Basierend auf dem PIP-Assessment des Zentrum für Qualität in der Pfege www.zqp.de',
  },
  loginBtn: {
    defaultMessage: 'Login',
  },
  imageCopyright1: {
    defaultMessage: 'Bild von storyset auf Freepik',
  },
  imageCopyright2: {
    defaultMessage: 'Bild von Freepik',
  },
  copyright: {
    defaultMessage:
      '© {now, date, ::yyyy} freshcells systems engineering GmbH',
  },
  copyrightReserved: {
    defaultMessage: 'All rights reserved',
  },
})
